(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSMovimientoEstatusProyectoDeleteController',SSMovimientoEstatusProyectoDeleteController);

    SSMovimientoEstatusProyectoDeleteController.$inject = ['$uibModalInstance', 'entity', 'SSMovimientoEstatusProyecto'];

    function SSMovimientoEstatusProyectoDeleteController($uibModalInstance, entity, SSMovimientoEstatusProyecto) {
        var vm = this;

        vm.sSMovimientoEstatusProyecto = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            SSMovimientoEstatusProyecto.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
